import { z } from 'zod'

export const registerFormSchema = z
  .object({
    email: z.email('auth:errors.invalidEmail').min(1, 'auth:errors.emailRequired'),
    password: z.string().min(8, 'auth:errors.weakPassword'),
    confirmPassword: z.string().min(1, 'auth:errors.passwordRequired'),
    firstName: z.string().min(1, 'auth:errors.firstNameRequired'),
    lastName: z.string().min(1, 'auth:errors.lastNameRequired'),
    phone: z.string().optional(),
    privacyAccepted: z
      .boolean()
      .refine((val) => val === true, { message: 'auth:errors.privacyAcceptedRequired' }),
    facility: z.object({
      name: z.string().min(1, 'auth:errors.facilityNameRequired'),
      address: z.string().min(1, 'auth:errors.facilityAddressRequired'),
      city: z.string().min(1, 'auth:errors.facilityCityRequired'),
      postalCode: z.string().optional(),
      phone: z.string().min(1, 'auth:errors.facilityPhoneRequired'),
      email: z.email('auth:errors.invalidEmail').optional().or(z.literal('')),
      bedCount: z.number().int().positive('auth:errors.bedCountRequired'),
      bulstat: z.string().optional(),
      registrationNumber: z.string().optional(),
    }),
  })
  .refine((data) => data.password === data.confirmPassword, {
    message: 'auth:errors.passwordMismatch',
    path: ['confirmPassword'],
  })

export type RegisterFormValues = z.infer<typeof registerFormSchema>

export const defaultRegisterValues: RegisterFormValues = {
  email: '',
  password: '',
  confirmPassword: '',
  firstName: '',
  lastName: '',
  phone: '',
  privacyAccepted: false,
  facility: {
    name: '',
    address: '',
    city: '',
    postalCode: '',
    phone: '',
    email: '',
    bedCount: 1,
    bulstat: '',
    registrationNumber: '',
  },
}

export const REGISTER_STEPS = {
  PERSONAL: 0,
  FACILITY: 1,
} as const

export type RegisterStep = (typeof REGISTER_STEPS)[keyof typeof REGISTER_STEPS]
